import './Collection.scss';
import React, { Component } from 'react';
import MediaItem from '../mediaItem/MediaItem';

type CollectionItem = {
    id?: string;
    isSelectable?: boolean;
    isEditable?: boolean;
    isAddable?: boolean;
    isRemovable?: boolean;
    isDraggable?: boolean;
    hasDigitalSignature?: boolean;
    hasMoreOptions?: boolean;
    [key: string]: any;
};

type CollectionProps = {
    items: CollectionItem[];
    type?: string;
    name: string;
    className?: string;
    onAddIconClick?: (item: CollectionItem) => void;
    [key: string]: any;
};

class Collection extends Component<CollectionProps> {
    collectionElement: HTMLDivElement | null = null;

    render() {
        const items: React.ReactNode[] = [];

        this.props.items.forEach((item, index) => {
            const element = (
                <div
                    key={item.id ?? index}
                    className="b-collection-item"
                    ref={e => {
                        this.collectionElement = e;
                    }}
                >
                    <MediaItem
                        name={`media-item-${index + 1}`}
                        data={item}
                        onAddIconClick={this.props.onAddIconClick || (() => null)}
                    />
                </div>
            );

            items.push(element);
        });

        return (
            <div
                className={`b-collection ${this.props.className || ''} ${
                    this.props.type ? this.props.type : ''
                }`}
                id={this.props.name}
                data-testid={`collection-${this.props.name}`}
            >
                {items}
            </div>
        );
    }
}

export default Collection;